export default "__VITE_ASSET__DMjnVNHJ__"